import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useContext, useState } from 'react';
import { OrganisationsContext } from '../../Contexts/OrganisationsContext';
import { APIContext } from '../../Contexts/APIContext';

interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
}

export default function SearchFiltersDialog(props: IProps) {
    const { post } = useContext(APIContext);
    const { filterState } = useContext(OrganisationsContext);
    const { open, onClose } = props;
    const [name, setName] = useState("");

    const handleSave = () => {
        post('OrganisationFilter', `SaveFilterQuery?name=${name}`, filterState, () => onClose(true));
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Save Current Query Filters</DialogTitle>
            <DialogContent>
                <TextField
                    sx={{ mt: 1 }}
                    fullWidth
                    size="small"
                    label="Query Name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
                <DialogActions>
                    <Button disabled={name.length === 0} onClick={handleSave} variant="contained">Save</Button>
                    <Button onClick={() => onClose(false)} color="error">Cancel</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}